import { cancelledStatus, filledStatus, inactiveStatus, openStatus, rejectedStatus } from "../assets/colors"
import { Order, OrderStatus } from "../proto/generated/order"
import { Security } from "../proto/generated/security"
import { addOrderFiredAlert, OrdersDataType } from "../reducer/orders.reducer"
import store from "../store"

export function gcd(a: number, b: number): number {
    return b === 0 ? a : gcd(b, a % b)
}

export function calculateGcd(arr: number[]) {
    if(arr.length===0) return 0
    const gcdOfArray: number = arr.reduce(gcd)
    return gcdOfArray
}

export const findOrderPremium = (order: OrdersDataType, security: Security | undefined): string => {
    let result
    if(order.contractType === 'FUTURE') return '0'
    if (order.type === 'sell') {
        if (order.callput === 'call') {
            result = order.data.callOption?.topBid
        } else {
            result = order.data.putOption?.topBid
        }
    } else {
        if (order.callput === 'call') {
            result = order.data.callOption?.topAsk
        } else {
            result = order.data.putOption?.topAsk
        }
    }
    result = (result ?? 0) / (security?.priceMultiplier ?? 100)
    return String(result)
}

export const addOrderAlertMessage = (order: Order) => {
    store.dispatch(addOrderFiredAlert({
        ...order,
        exchangeTimestamp: Date.now() - 100
    }))
}

export const getRoundedPrice = (priceAsInt: number, tickSize = 5) => Math.round( priceAsInt/ tickSize) * tickSize;


export const getOrderStatusColor = (status: OrderStatus) => {
    switch (status) {
        case OrderStatus.OPEN:
        case OrderStatus.PENDING:
        case OrderStatus.TRIGGER_PENDING:
            return openStatus;
        case OrderStatus.EXECUTED:
        case OrderStatus.PARTIALLY_FILLED:
            return filledStatus;
        case OrderStatus.INACTIVE:
            return inactiveStatus;
        case OrderStatus.CANCELLED:
            return cancelledStatus;
        case OrderStatus.FAILED:
        case OrderStatus.REJECTED:
            return rejectedStatus;
        default:
            return "black";
    }   
}


const orderStatusTextMap: Record<OrderStatus, string> = {
    [OrderStatus.OPEN]: "Open",
    [OrderStatus.PENDING]: "Pending",
    [OrderStatus.TRIGGER_PENDING]: "Trig. Pending",
    [OrderStatus.EXECUTED]: "Filled",
    [OrderStatus.PARTIALLY_FILLED]: "Part. Filled",
    [OrderStatus.INACTIVE]: "Inactive",
    [OrderStatus.CANCELLED]: "Cancelled",
    [OrderStatus.FAILED]: "Failed",
    [OrderStatus.REJECTED]: "Rejected",
    [OrderStatus.ORDER_STATUS_UNKNOWN]: "-",
    [OrderStatus.UNRECOGNIZED]: "-"

}

export const getOrderStatusText = (status: OrderStatus) => {
    return orderStatusTextMap[status]
}